module.exports = __webpack_public_path__ + "img/confirm-action-note.d8fe6d9.jpg";